export const formFields = {
  handle: 'handle',
  firstName: 'firstName',
  lastName: 'lastName',
  work_title: 'work_title',
  company: 'company',
  country: 'country',
  city: 'city',
}
